// extracted by mini-css-extract-plugin
module.exports = {"root":"MainBar_root"};